"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./InlineTooltip.css");
require("./InlineTooltip.tablet.css");
require("./InlineTooltip.desktop.css");
var OnClickOutside_1 = require("../../../behaviors/OnClickOutside/OnClickOutside");
var icons = require("./../../../../styles/att-icons.css");
var InlineTooltip = /** @class */ (function (_super) {
    __extends(InlineTooltip, _super);
    function InlineTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showTooltip: false };
        _this.idName = "inlineTooltip" + InlineTooltip.counter++;
        _this.setIconRef = _this.setIconRef.bind(_this);
        _this.toggleTooltip = _this.toggleTooltip.bind(_this);
        _this.closeTooltip = _this.closeTooltip.bind(_this);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        return _this;
    }
    InlineTooltip.prototype.componentDidUpdate = function () {
        if (this.state.showTooltip) {
            window.document.addEventListener('touchstart', this.onDocumentClick);
            return;
        }
        this.clearOutsideHandler();
    };
    InlineTooltip.prototype.componentWillUnmount = function () {
        this.clearOutsideHandler();
    };
    InlineTooltip.prototype.onDocumentClick = function (e) {
        if ((e.target !== this.IconRef) && (e.target.nodeName !== 'A')) {
            this.closeTooltip();
        }
    };
    InlineTooltip.prototype.clearOutsideHandler = function () {
        document.removeEventListener('touchstart', this.onDocumentClick);
    };
    InlineTooltip.prototype.render = function () {
        return (this.getTextType());
    };
    InlineTooltip.prototype.closeTooltip = function () {
        this.setState({ showTooltip: false });
    };
    InlineTooltip.prototype.toggleTooltip = function () {
        this.setState({ showTooltip: !this.state.showTooltip });
    };
    InlineTooltip.prototype.shouldShowTooltip = function () {
        return this.state.showTooltip;
    };
    InlineTooltip.prototype.getContentClasses = function () {
        return [this.props.options.isRennyStyle ? styles.tooltipContentRenny : styles.tooltipContent,
            this.props.options.className,
            this.shouldShowTooltip() ? styles.show : '',
        ].join(' ');
    };
    InlineTooltip.prototype.getTooltipTipContainerClasses = function () {
        return [this.props.options.isRennyStyle ? styles.tooltipTipContainerRenny : styles.tooltipTipContainer,
            this.shouldShowTooltip() ? styles.show : '',
        ].join(' ');
    };
    InlineTooltip.prototype.setIconRef = function (element) {
        this.IconRef = element;
    };
    InlineTooltip.prototype.getButtonAccessibility = function () {
        var showTooltip = this.shouldShowTooltip();
        return Object.assign({
            'aria-expanded': showTooltip,
            'aria-label': 'Onclick tooltip label Help',
        }, showTooltip ? { 'aria-describedby': this.idName } : {});
    };
    InlineTooltip.prototype.getContentAccessibility = function () {
        return {
            'aria-hidden': !this.shouldShowTooltip(),
            'aria-live': 'polite',
            id: this.idName,
        };
    };
    InlineTooltip.prototype.getTextType = function () {
        var cssClasses = [
            this.props.options.isRennyStyle ? styles.tooltipContainerRenny : styles.tooltipContainer,
            this.props.options.className,
        ];
        return (React.createElement("div", { className: cssClasses.join(' ') },
            React.createElement("button", __assign({ "data-test-id": this.props.testId, className: this.props.options.isRennyStyle ? styles.tooltipButtonRenny : styles.tooltipButton, onClick: this.toggleTooltip, onBlur: this.closeTooltip }, this.getButtonAccessibility()),
                React.createElement("i", { className: [icons.attIcon, icons.attIconNumbersLettersFlatFaq, this.props.options.isRennyStyle ? styles.iconStylesRenny : styles.iconStyles].join(' '), ref: this.setIconRef })),
            React.createElement("div", { className: this.getTooltipTipContainerClasses() }),
            this.state.showTooltip ? (React.createElement(OnClickOutside_1.default, { events: { onClickOutside: this.closeTooltip } })) : null,
            React.createElement("div", __assign({ tabIndex: 0, className: this.getContentClasses() }, this.getContentAccessibility()), this.props.children)));
    };
    InlineTooltip.counter = 0;
    return InlineTooltip;
}(React.Component));
exports.default = InlineTooltip;
//# sourceMappingURL=InlineTooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/InlineTooltip/InlineTooltip.js
// module id = 516
// module chunks = 8